var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View } from 'react-native';
import { getUpsellCellStyles } from './UpsellCellStyles';
import { UpsellSubsection } from '../upsell-subsection';
import { UpsellSubTitle } from '../upsell-subtitle';
import { getTestId, isValidObject, useBreakpoint } from '@airtel/air-design-system';
export var UpsellCell = props => {
  var style = props.style,
    propsWithoutStyle = __rest(props, ["style"]);
  var _a = propsWithoutStyle !== null && propsWithoutStyle !== void 0 ? propsWithoutStyle : {},
    subSection = _a.subSection,
    iconName = _a.iconName,
    subTitle = _a.subTitle,
    subTitleDescription = _a.subTitleDescription,
    testID = _a.testID,
    onUserAction = _a.onUserAction,
    infoTagModel = _a.infoTagModel,
    restProps = __rest(_a, ["subSection", "iconName", "subTitle", "subTitleDescription", "testID", "onUserAction", "infoTagModel"]);
  var upsellTitleStyles = getUpsellCellStyles();
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  return _jsxs(View, Object.assign({}, getTestId(testID), {
    style: [upsellTitleStyles.container, style]
  }, restProps, {
    children: [(subTitle || subTitleDescription) && _jsx(UpsellSubTitle, Object.assign({}, getTestId(testID, 'subtitle'), propsWithoutStyle, {
      isMobileScreen: isSmallScreen
    })), (subSection || iconName || isValidObject(infoTagModel)) && _jsx(UpsellSubsection, Object.assign({}, getTestId(testID, 'subSection'), propsWithoutStyle, {
      isMobileScreen: isSmallScreen,
      onUserAction: onUserAction
    }))]
  }));
};